document.addEventListener('DOMContentLoaded', function() {
    let variantsPlacement = document.querySelector('#technical-spec_container table'),
        variantMetafields = document.getElementById('technical-spec_container_st'),
        lastRow = variantsPlacement.querySelector('tbody tr:last-child');
    if (lastRow && variantMetafields) {
        lastRow.insertAdjacentHTML('afterend', variantMetafields.innerHTML);
    }
})
document.addEventListener('on:variant:change', (evt) => {
    let variant_id = evt.detail.variant.id,
        specificElement = document.querySelectorAll('.variant-metafield-' + variant_id);
    document.querySelectorAll('.variant-metafield').forEach(element => {
        element.style.display = "none";
    });
    specificElement.forEach(element => {
        element.style.display = "table-row";
    });
});